import { Form, Field } from 'react-final-form';
import { Button } from 'primereact/button';
import React, { useState,useRef } from "react";
import { Password } from "primereact/password";
import { classNames } from 'primereact/utils';
import { instance } from '../../../../api';
import { Toast } from 'primereact/toast';

export default function ResetPassword({ setDialogReset,showToast}) {
    const toast = useRef(null);
    const onSubmit = async (data) => {
        try {
            const response = await instance.post('/api/utilisateurs/change-password', data);
    
            // Check for successful response
            if (response.status === 200) {
                // Close the dialog on success
                setDialogReset(false);
    
                // Show success message
                showToast('success', 'Succès', 'Mot de passe modifié avec succès');
            } else {
                // Handle unexpected status codes
                const errorMessage = response.data?.resultat || 'Une erreur inconnue s\'est produite';
                showToast('error', 'Erreur', errorMessage);
            }
        } catch (error) {
            console.error('Error Response:', error.response);
    
            // Handle errors thrown by the API or network issues
            const errorMessage =
                error.response?.data?.resultat === "ancien mot de passe n'existe pas"
                    ? 'Ancien mot de passe incorrect'
                    : 'Une erreur inconnue s\'est produite';
    
            showToast('error', 'Erreur', errorMessage);
        }
    };
    
    
    
    const [passwordCriteria, setPasswordCriteria] = useState({
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
        specialChar: false,
        match: false,
    });
   
    
    const updatePasswordCriteria = (password, confirmPassword) => {
        const criteria = {
            length: password.length >= 6,
            uppercase: /[A-Z]/.test(password),
            lowercase: /[a-z]/.test(password),
            number: /\d/.test(password),
            specialChar: /[@$!%*?&]/.test(password),
        };
        setPasswordCriteria(criteria);
    };
    const validate = (data) => {
        let errors = {};
        if (!data.oldPassword ) {
            errors.oldPassword  = ' Ce champ est obligatoire.';
        }

        if (!data.password ) {
            errors.password  = 'Ce champ est obligatoire.'
        }
        else {
            updatePasswordCriteria(data.password);
            if (!passwordCriteria.length || !passwordCriteria.uppercase || !passwordCriteria.lowercase || !passwordCriteria.number || !passwordCriteria.specialChar) {
                errors.password = 'Le mot de passe doit respecter tous les critères requis.';
            }
        }

        if (!data.confirmPassword ) {
            errors.confirmPassword = 'Ce champ est obligatoire'; 
        } else if (data.confirmPassword !== data.password ) {
            errors.confirmPassword = 'Mots de passe non identiques'; 
        }

        return errors;
    };
    const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
    const getFormErrorMessage = (meta) => {
        return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
    };
    return (
        <div>
            <Toast ref={toast} />
            <Form onSubmit={onSubmit} initialValues={{ oldPassword : '', password : '', confirmPassword : '' }} validate={validate} render={({ handleSubmit ,values}) => (
                <form onSubmit={handleSubmit} className="p-fluid">
                    <Field name="oldPassword" render={({ input, meta }) => (
                        <div className="p-field">
                            <span className="p-float-label p-input-icon-right">
                                <Password id="oldPassword" toggleMask feedback={false} {...input} className={classNames({ 'p-invalid': isFormFieldValid(meta) })} />
                                <label htmlFor="oldPassword" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Mot de passe actuel  *</label>
                            </span>
                            {getFormErrorMessage(meta)}
                        </div>
                    )} />

                    <Field name="password" render={({ input, meta }) => (
                        <div className="p-field">
                            <span className="p-float-label p-input-icon-right">

                                <Password id="password" toggleMask feedback={false} {...input} onInput={(e) => updatePasswordCriteria(e.target.value, values.confirmPassword)} className={classNames({ 'p-invalid': isFormFieldValid(meta) })} />
                                <label htmlFor="password" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Nouveau mot de passe *</label>
                            </span>
                            {getFormErrorMessage(meta)}
                        </div>
                    )} />

                    <Field name="confirmPassword" render={({ input, meta }) => (
                        <div className="p-field">
                            <span className="p-float-label p-input-icon-right">

                                <Password id="confirmPassword" toggleMask feedback={false} {...input} className={classNames({ 'p-invalid': isFormFieldValid(meta) })} />
                                <label htmlFor="confirmPassword" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Confirmation  mot de passe *</label>
                            </span>
                            {getFormErrorMessage(meta)}
                        </div>
                    )} />
                     <ul className="password-criteria" style={{ fontSize: "0.85rem" }}>
                                            <li style={{ color: passwordCriteria.length ? "green" : "red" }}>{passwordCriteria.length ? "✓" : "✗"} Le mot de passe contient au moins 6 caractères</li>
                                            <li style={{ color: passwordCriteria.specialChar ? "green" : "red" }}>{passwordCriteria.specialChar ? "✓" : "✗"} Le mot de passe contient un caractère spécial</li>
                                            <li style={{ color: passwordCriteria.number ? "green" : "red" }}>{passwordCriteria.number ? "✓" : "✗"} Le mot de passe contient un chiffre</li>
                                            <li style={{ color: passwordCriteria.uppercase ? "green" : "red" }}>{passwordCriteria.uppercase ? "✓" : "✗"} Le mot de passe contient une majuscule</li>
                                            <li style={{ color: passwordCriteria.lowercase ? "green" : "red" }}>{passwordCriteria.lowercase ? "✓" : "✗"} Le mot de passe contient une minuscule</li>
                    </ul>
                 
                    <div className='btnContact'>
                       
                        <Button type="submit" label="Envoyer" className="p-mt-2 send"  />
                    </div>

                </form>
         )} />

        </div>

    )
}
